import { InitialState } from "../reducers"
import { ApiSupportSelector } from "../../../helpers/apiSupport"

export const Selector = {
    get: (state): InitialState => {
        return state.inventory.stockLocation
    },

    getId: (state) => {
        return Selector.get(state).id
    },

    getName: (state) => {
        return Selector.get(state).name
    },

    getLocationIDs: (state) =>{
        return Selector.get(state).locationIds
    } ,

    getListing: (state) => { 
        return Selector.get(state).listing
    },

    getSingleInventory: (state) => {
        return {
            id: Selector.getId(state),
            name: Selector.getName(state),
            locationIds: Selector.getLocationIDs(state)
        }
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))

    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/location/selectors/selectors.ts